import {ExportFormValues} from 'plans/types/ExportFormValues';
import {ExportFormProps} from './index';

export const validate = (values: ExportFormValues, props: ExportFormProps) => {
    const errors: { [_ in keyof ExportFormValues]?: string } = {};
    if (!values.month) { errors.month = 'Měsíc je povinná položka.'; }
    if (props.adminMode && !values.user) { errors.user = 'Uživatel je povinná položka.'; }
    return errors;
};
